export default __webpack_public_path__ + "static/Rev-Coin-case-study-image-04686894a3b47de890856f49b80e1a5c.webp";